import { Component, OnInit } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { AuthenticationResult } from '@azure/msal-browser';
import { UserService } from './core/services/user.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  constructor(private msalService: MsalService, private userService: UserService) { }
  ngOnInit(): void {
    // Hide DevExtreme license watermark immediately and with delays
    this.hideDevExtremeLicense();

    setTimeout(() => this.hideDevExtremeLicense(), 100);
    setTimeout(() => this.hideDevExtremeLicense(), 500);
    setTimeout(() => this.hideDevExtremeLicense(), 1000);
    setTimeout(() => this.hideDevExtremeLicense(), 2000);
    setTimeout(() => this.hideDevExtremeLicense(), 3000);
    setTimeout(() => this.hideDevExtremeLicense(), 5000);

    // Set up MutationObserver to continuously monitor for license elements
    this.setupLicenseObserver();

    this.msalService.instance.handleRedirectPromise().then((result) => {
      if (result) {
        this.msalService.instance.setActiveAccount(result.account);
        const name = result.account.name ?? 'Guest';
        const email = result.account.username ?? '';
        //localStorage.setItem('username', name);
        this.userService.logUserLogin({ userName: name, emailAddress: email }).subscribe();
      } else {
        const active = this.msalService.instance.getActiveAccount();
        if (!active) {
          this.msalService.loginRedirect(); // automatic login
        }
        else {
          const name = active.name ?? 'Guest';
          const email = active.username ?? '';
          //localStorage.setItem('username', name);
          this.userService.logUserLogin({ userName: name, emailAddress: email }).subscribe();
        }
      }
    });
  }

  private setupLicenseObserver(): void {
    const observer = new MutationObserver(() => {
      this.hideDevExtremeLicense();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    });
  }

  private hideDevExtremeLicense(): void {
    const licenseElements = document.querySelectorAll('.dx-license, [class*="dx-license"], dx-license, [style*="dx-license"]');
    licenseElements.forEach(element => {
      const htmlElement = element as HTMLElement;
      htmlElement.style.display = 'none !important';
      htmlElement.style.opacity = '0 !important';
      htmlElement.style.visibility = 'hidden !important';
      htmlElement.style.pointerEvents = 'none !important';
      htmlElement.style.position = 'absolute !important';
      htmlElement.style.left = '-9999px !important';
      htmlElement.style.top = '-9999px !important';
      htmlElement.style.width = '0 !important';
      htmlElement.style.height = '0 !important';
      htmlElement.style.overflow = 'hidden !important';
      htmlElement.style.zIndex = '-9999 !important';
      // Remove the element from DOM completely
      htmlElement.remove();
    });

    // Also check for any elements containing license text
    const allElements = document.querySelectorAll('*');
    allElements.forEach(element => {
      if (element.textContent && element.textContent.includes('For evaluation purposes only')) {
        const htmlElement = element as HTMLElement;
        htmlElement.style.display = 'none !important';
        htmlElement.remove();
      }
    });
  }
  title = 'alloc8';
}
